<button
  class="h-full rounded-md px-3 py-1 font-bold"
  [class.w-full]="full()"
  [ngClass]="isActive() ? 'bg-primary-600 text-white' : 'bg-primary-100 text-primary-600'"
  (click)="buttonClick.emit(clickPayload())"
>
  @if (text() && !otherAmount()) {
    <span>
      {{ text() }}
    </span>
  }
  @if (otherAmount()) {
    <div class="flex flex-col items-center justify-center">
      <div class="flex items-center">
        <span class="notranslate mr-0.5 text-base">
          {{ otherAmount() }}
        </span>
        <span class="text-base">
          <app-currency-atom></app-currency-atom>
        </span>
      </div>
      <span class="text-xs">{{ 'tip-modal.edit' | translate }}</span>
    </div>
  }
  @if (value() && !text()) {
    <div class="flex flex-col items-center justify-center">
      <div>
        <span class="notranslate mr-1 text-base">{{ value() }}</span>
        @if (type() === 'percent') {
          <span class="text-base">%</span>
        }
        @if (type() === 'currency') {
          <span class="text-base"><app-currency-atom></app-currency-atom></span>
        }
      </div>
      @if (secondaryAmount() !== undefined && secondaryAmount() !== null) {
        <div class="text-xs">
          <span class="notranslate mr-1">{{ secondaryAmount() }}</span>
          <app-currency-atom />
        </div>
      }
    </div>
  }
</button>
